import { BuildNode } from "@common/build/types";
import { BuilderState } from "../types";

export default function applyDefaultStyles(newNode: BuildNode, state: BuilderState, parentNode?: BuildNode) {
    if (!newNode.attr) {
        newNode.attr = {};
    }
    if (!newNode.attr.style) {
        newNode.attr.style = {};
    }
    // map style properties may be frozen
    try {
        newNode.attr.style.fontFamily = "inherit";
    } catch (e) {
        console.error("error: ", e);
    }

    if (newNode.name === "baseLayerPage" || newNode.name === "baseLayerPopup" || newNode.name === "baseLayerCFD") {
        newNode.attr.style.fontFamily = state.build.extraAttributes?.fonts?.[0]?.name || "Poppins";
    } else if (newNode.name === "text") {
        newNode.attr.style = {
            ...newNode.attr.style,
            width: "fit-content"
        };
    } else if (newNode.name === "div" || newNode.name === "templateDiv") {
        newNode.attr.style = {
            ...newNode.attr.style,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            borderRadius: "8px 8px 8px 8px",
            alignItems: "center",
            gap: "20px"
        };
    } else if (newNode.name === "repeaterDiv") {
        newNode.attr.style = {
            ...newNode.attr.style,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            gap: "20px",
            borderRadius: "8px 8px 8px 8px",
            alignItems: "center",
            boxShadow: "0px 6px 10px 0px #5E5E5E1A"
        };
    } else if (newNode.name === "iframe") {
        newNode.attr.style = {
            ...newNode.attr.style,
            width: "100%",
            height: "100%"
        };
    }

    if (newNode.nodeSize) {
        if (parentNode?.attr?.style?.flexDirection === "row") {
            if (newNode.nodeSize.width === "fill") {
                newNode.attr.style.width = "0px";
                newNode.attr.style.flexGrow = "1";
            }
            if (newNode.nodeSize.height === "fill") {
                newNode.attr.style.height = "100%";
            }
        } else {
            if (newNode.nodeSize.width === "fill") {
                newNode.attr.style.width = "100%";
            }
            if (newNode.nodeSize.height === "fill") {
                newNode.attr.style.height = "0px";
                newNode.attr.style.flexGrow = "1";
            }
        }
    }
}
